import { apiGet } from '@/store/api';
import { useApplicationStore } from '@/store/applicationStore';

export async function getGlobalSettings() {
  const applicationStore = useApplicationStore();
  const data = await apiGet('helper/globalSettings');
  applicationStore.setGlobalSettings(data[0]);
}
